import React from 'react';
import AnimateIn from './AnimateIn';
import './ReasonsSection.css';

/* Proven Experience – person with heart, stars */
const IconExperience = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
    <path d="M12 11v2" />
    <path d="M12 11c-1.5 0-2.5.5-2.5 1.5 0 .7.5 1 1.5 1.5" />
    <path d="M12 14c.5.3 1 .5 1.5.5s1-.2 1.5-.5" />
    <path d="M8 5l1 2 2-1-1 2 2 1-2-1-1 2-1-2z" />
    <path d="M16 4l.5 1 1-.5-.5 1 1 .5-1-.5-.5 1-.5-1z" />
  </svg>
);

/* Dedicated Team – three figures */
const IconTeam = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    <path d="M12 11v4" />
    <path d="M10 15h4" />
  </svg>
);

/* Affordable Solutions – lightbulb */
const IconLightbulb = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 18h6" />
    <path d="M10 22h4" />
    <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14" />
  </svg>
);

/* On-Time Delivery – clock */
const IconDelivery = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const defaultReasons = [
  {
    id: 1,
    icon: 'experience',
    title: 'Proven Experience',
    description: 'Empowering learners with practical skills and real-world knowledge that translate into tangible career outcomes.',
  },
  {
    id: 2,
    icon: 'team',
    title: 'Dedicated Team',
    description: 'Skilled mentors and industry experts working together to deliver the best learning outcomes for every learner.',
  },
  {
    id: 3,
    icon: 'lightbulb',
    title: 'Affordable Solutions',
    description: 'Cost-effective training programs tailored to fit every budget while upholding exceptional learning standards.',
  },
  {
    id: 4,
    icon: 'delivery',
    title: 'On-Time Delivery',
    description: 'Training programs completed on time with precision, planning, and practical results.',
  },
];

const getIcon = (icon) => {
  switch (icon) {
    case 'experience':
      return <IconExperience />;
    case 'team':
      return <IconTeam />;
    case 'lightbulb':
      return <IconLightbulb />;
    case 'delivery':
      return <IconDelivery />;
    default:
      return <IconExperience />;
  }
};

const ReasonsSection = ({ title, reasons }) => {
  const list = reasons && reasons.length > 0 ? reasons : defaultReasons;

  return (
    <section className="reasons-section" id="reasons">
      <div className="reasons-section-container">
        <h2 className="reasons-section-title">{title || 'Why Choose Us'}</h2>
        <div className="reasons-section-grid">
          {list.map((item, i) => (
            <AnimateIn
              key={item.id}
              direction={i % 2 === 0 ? 'left' : 'right'}
              delay={i * 100}
              className="reasons-card-wrap"
            >
              <article className="reasons-card">
                <div className="reasons-card-corner reasons-card-corner-tl" />
                <div className="reasons-card-corner reasons-card-corner-tr" />
                <div className="reasons-card-corner reasons-card-corner-bl" />
                <div className="reasons-card-corner reasons-card-corner-br" />
                <div className="reasons-card-icon-wrap">
                  {getIcon(item.icon)}
                </div>
                <h3 className="reasons-card-title">{item.title}</h3>
                <p className="reasons-card-description">{item.description}</p>
              </article>
            </AnimateIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReasonsSection;
